import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { BehaviorSubject, map, Observable, Subject } from 'rxjs';
import { Stakeholder } from './types/Stakeholder';
import { Router } from '@angular/router';
import { Title } from '@angular/platform-browser';

@Injectable({
  providedIn: 'root',
})
export class AppService {
  apiUrl = environment.pimaApiUrl;

  isMobile = new BehaviorSubject<boolean>(false);

  pageIndex = new BehaviorSubject<number>(0);

  survey123Url = new BehaviorSubject<string>(`${environment.survey123URL}`);

  private scrollToTopSubject = new Subject<void>();
  scrollToTop$ = this.scrollToTopSubject.asObservable();

  private stakeholderObj = new BehaviorSubject<Stakeholder>({
    FirstName: '',
    LastName: '',
    StakeId: '',
    StakeGuid: '',
  });

  pages: string[] = [
    'Welcome!',
    'Project Overview',
    'Environmental',
    'Traffic',
    'Alternatives',
    'Public Comment',
  ];

  constructor(
    private httpClient: HttpClient,
    private router: Router,
    private titleService: Title
  ) {}

  validateStakeholderGuid(stakeholderGuid: string): Observable<Stakeholder> {
    return this.httpClient.get<Stakeholder>(
      `${this.apiUrl}/ValidatePublicStakeholderGUID?stakeGUID=${stakeholderGuid}`
    );
  }

  validateStakeholderEmail(
    stakeEmail: string,
    stakeGuid: string
  ): Observable<boolean> {
    return this.httpClient.get<boolean>(
      `${this.apiUrl}/ValidatePublicStakeholderEmail?stakeGUID=${stakeGuid}&stakeEmail=${stakeEmail}`
    );
  }

  updateStakeholder(stakeholder: Stakeholder): void {
    this.stakeholderObj.next(stakeholder);
  }

  getStakeholder() {
    return this.stakeholderObj.asObservable();
  }

  getIsMobile() {
    return this.isMobile.asObservable();
  }

  setIsMobile(isMobile: boolean) {
    this.isMobile.next(isMobile);
  }

  setPageIndex(index: number) {
    this.pageIndex.next(index);
    this.titleService.setTitle(
      `I-24 Southeast Choice Lanes - ${this.pages[index]}`
    );

    const pageSlug = this.pages[index]
      .toLowerCase()
      .replace(/\s+/g, '-')
      .replace(/[^\w-]/g, '');

    this.router.navigate([`/${pageSlug}`]);
  }

  getPageIndex() {
    return this.pageIndex.asObservable();
  }

  getSurvey123Url(): Observable<string> {
    return this.stakeholderObj.asObservable().pipe(
      map((stakeholder) => {
        const stakeId = stakeholder.StakeId;
        const projectId = environment.pimaProjectId;

        return `${environment.survey123URL}?field:stakeholder_id=${stakeId}&field:project_id=${projectId}&hide=field:stakeholder_id,field:project_id`;
      })
    );
  }

  emitScrollToTop() {
    this.scrollToTopSubject.next();
  }
}
